import type { SiteEligibilityLocale } from "@/locales/fr/site-eligibility";

const siteEligibilityLocale: SiteEligibilityLocale = {
  siteEligibility: {
    pageTitle: "Eligibility",
    cardTitle: "Update site eligibility criteria for ESC",
    yes: "Yes",
    no: "No",
    isBuildingMoreThan2YearsOld: "Building is older than 2 years ?",
    areAllHeatersWired: "All the heating appliances have been installed ?",
    isNotPro: "Non-professional site",
    hasNoSiteHeatPump: {
      title: "Heatpump present on the site (installed or not)",
      none: "None",
      atLeastOne: "At least one",
      unqualifiedWarning:
        "Heat pump declared by the subscriber, without brand or model. Fill them in during the call, or select “None” if the subscriber has none.",
      qualifyButton: "Fill in brand and model",
    },
    back: "Back",
    submit: "Submit",
    escUpgradeModal: {
      title: "Upgrade to sale",
      siteIsUpgradeable: "This site is upgradeable to a sale flow. A new signature must be sent to the subscriber",
      cta: "Upgrade to sale",
    },
  },
};

export default siteEligibilityLocale;
